import React from 'react';
import { useLanguage } from '../context/LanguageContext';

// Authentic stock photography - licensed for use from Unsplash and Pexels
// Illustrative photos representing diverse communities and everyday situations
const illustrativePhotos = [
  {
    id: 1,
    image: "https://images.pexels.com/photos/6249928/pexels-photo-6249928.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Family enjoying quality time together at home",
    objectPosition: "center"
  },
  {
    id: 2,
    image: "https://images.pexels.com/photos/7919634/pexels-photo-7919634.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Family spending time together indoors",
    objectPosition: "center"
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1735671822151-d0f984719f98?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxkaXZlcnNlJTIwY291cGxlJTIwY2FyJTIwZHJpdmluZyUyMGhhcHB5JTIwbGlmZXN0eWxlfGVufDB8fHx8MTc5MzY2NTI3NXww&ixlib=rb-4.1.0&q=85",
    alt: "Couple in car during everyday commute",
    objectPosition: "center"
  },
  {
    id: 4,
    image: "https://images.unsplash.com/photo-1575267685970-7fbabf6ed7b0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxtYXR1cmUlMjBhZHVsdHMlMjBob21lJTIwaW5zdXJhbmNlJTIwbGlmZXN0eWxlJTIwbmF0dXJhbHxlbnwwfHx8fDE3OTM2NjUyNzV8MA&ixlib=rb-4.1.0&q=85",
    alt: "Adults enjoying outdoor lifestyle",
    objectPosition: "center top"
  },
  {
    id: 5,
    image: "https://images.unsplash.com/photo-1747832512459-5566e6d0ee5a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMG93bmVyJTIwc2hvcCUyMGF1dGhlbnRpYyUyMHByb2Zlc3Npb25hbHxlbnwwfHx8fDE3OTM2NjUyODF8MA&ixlib=rb-4.1.0&q=85",
    alt: "Business owner in professional setting",
    objectPosition: "center"
  },
  {
    id: 6,
    image: "https://images.unsplash.com/photo-1758876202699-abeb827f35b8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxlbnRyZXByZW5ldXIlMjBzbWFsbCUyMGJ1c2luZXNzJTIwd29ya3NwYWNlJTIwcHJvZmVzc2lvbmFsfGVufDB8fHx8MTc5MzY2NTI4N3ww&ixlib=rb-4.1.0&q=85",
    alt: "Entrepreneur working in small business workspace",
    objectPosition: "center"
  }
];

const HappyCustomers = () => {
  const { language } = useLanguage();

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {language === 'en' 
              ? 'People and Businesses We Help Protect'
              : 'Las personas y negocios que protegemos'}
          </h2>
          <p className="text-sm text-gray-500 italic mt-2">
            {language === 'en' ? 'Illustrative photos' : 'Fotos ilustrativas'}
          </p>
        </div>

        {/* Photo Gallery */}
        <div className="relative overflow-hidden">
          <div className="flex animate-scroll gap-4">
            {/* Duplicate items for seamless scrolling */}
            {[...illustrativePhotos, ...illustrativePhotos, ...illustrativePhotos].map((photo, index) => (
              <div
                key={`photo-${index}`}
                className="flex-shrink-0 w-80 h-72 rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105"
              >
                <img
                  src={photo.image}
                  alt={photo.alt}
                  className="w-full h-full object-cover"
                  style={{ objectPosition: photo.objectPosition }}
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HappyCustomers;